import { Size } from '../../primitives/size';
import { DrawingElement } from './drawing-element';
import { measureText } from './../../utility/dom-util';
/**
 * TextElement is used to display text/annotations
 */
export class TextElement extends DrawingElement {
    /**
     * set the id for each element
     */
    constructor() {
        super();
        /**
         * sets or gets the image source
         */
        this.textContent = '';
        /** @private */
        this.canMeasure = true;
        /** @private */
        this.canConsiderBounds = true;
        /** @private */
        this.doWrap = true;
        this.textNodes = [];
        /**
         * Defines the appearance of the text element
         */
        this.style = {
            color: 'black', fill: 'transparent', strokeColor: 'black',
            strokeWidth: 1, fontFamily: 'Arial', fontSize: 12, whiteSpace: 'CollapseSpace',
            textWrapping: 'WrapWithOverflow', textAlign: 'Center', italic: false, bold: false,
            textDecoration: 'None', strokeDashArray: '', opacity: 1,
            textOverflow: 'Wrap'
        };
        this.style.fill = 'transparent';
        this.style.strokeColor = 'transparent';
    }
    /**
     * gets the content for the text element
     */
    get content() {
        return this.textContent;
    }
    /**
     * sets the content for the text element
     */
    set content(value) {
        if (this.textContent !== value) {
            this.textContent = value;
            this.isDirt = true;
            this.doWrap = true;
        }
    }
    /**
     * sets the content for the text element
     */
    get childNodes() {
        return this.textNodes;
    }
    /**
     * gets the content for the text element
     */
    set childNodes(value) {
        this.textNodes = value;
    }
    /**
     * gets the wrapBounds for the text
     */
    get wrapBounds() {
        return this.textWrapBounds;
    }
    /**
     * sets the wrapBounds for the text
     */
    set wrapBounds(value) {
        this.textWrapBounds = value;
    }
    /** @private */
    refreshTextElement() {
        this.isDirt = true;
    }
    /**
     * Measures the minimum size that is required for the text element
     * @param availableSize
     */
    measure(availableSize) {
        let size;
        if (this.isDirt && this.canMeasure) {
            size = measureText(this, this.style, this.content, this.width || availableSize.width, availableSize.height);
        }
        else {
            size = this.desiredSize;
        }
        if (this.width === undefined || this.height === undefined) {
            this.desiredSize = new Size(size.width, size.height);
        }
        else {
            this.desiredSize = new Size(this.width, this.height);
        }
        this.desiredSize = this.validateDesiredSize(this.desiredSize, availableSize);
        return this.desiredSize;
    }
    /**
     * Arranges the text element
     * @param desiredSize
     */
    arrange(desiredSize) {
        if (desiredSize.width !== this.actualSize.width || desiredSize.height !== this.actualSize.height || this.isDirt) {
            this.doWrap = true;
        }
        this.actualSize = desiredSize;
        this.updateBounds();
        this.isDirt = false;
        return this.actualSize;
    }
}
